var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gender)?_c('NoFotoWoman'):_c('NoFotoMan')}
var staticRenderFns = []

export { render, staticRenderFns }